export default __webpack_public_path__ + "static/Richard.ColburnCHAIRBoardOfDirectors_social-e027b8aa5dc03a6077813fff78ee8235.jpg";